import { slideDown, slideUp, slideStop, isVisible } from "slide-anim";

import { section } from "@/glow";
import { listen, qsa, qs } from "@fluorescent/dom";
import { AnimateQuestions } from "@/lib/animation";

const selectors = {
  question: ".questions__accordion-label",
};

section("questions", {
  onLoad() {
    this.questions = qsa(selectors.question, this.container);
    this.clickHandlers = listen(this.questions, "click", e => {
      e.preventDefault();
      const { parentNode: group, nextElementSibling: content } =
        e.currentTarget;

      if (isVisible(content)) {
        this._close(e.currentTarget, group, content);
      } else {
        this._open(e.currentTarget, group, content);
      }
    });

    this.AnimateQuestions = AnimateQuestions(this.container);
  },

  _open(label, group, content) {
    slideStop(content, { duration: window.theme.animation.duration * 1000 });
    slideDown(content, { duration: window.theme.animation.duration * 1000 });

    this.AnimateQuestions.open(
      qs(".questions__accordion-answer-inner", content)
    );

    group.setAttribute("data-open", true);
    label.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);
  },

  _close(label, group, content) {
    slideStop(content, { duration: window.theme.animation.duration * 1000 });
    slideUp(content, { duration: window.theme.animation.duration * 1000 });

    this.AnimateQuestions.close(
      qs(".questions__accordion-answer-inner", content)
    );

    group.setAttribute("data-open", false);
    label.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
  },

  onBlockSelect({ target }) {
    const label = qs(selectors.question, target);
    const { parentNode: group, nextElementSibling: content } = label;

    this._open(label, group, content);
  },

  onUnload() {
    this.clickHandlers();
    this.AnimateQuestions?.destroy();
  },
});
